module.exports = __webpack_public_path__ + "static/img/class_25.f176b011.jpg";